import { Injectable } from '@angular/core';
import { UserProfileRole, UserProfileRoleFilters } from '../models/types/user-profile-role.type';

@Injectable({
	providedIn: 'root'
})
export class UserProfileRoleMapper {
	toUserProfileRole(node: any): UserProfileRole {
		return {
			id: node.id,
			role: {
				id: node.role?.id,
				name: node.role?.name
			},
			userProfile: {
				id: node.userProfile?.id,
				name: node.userProfile?.name,
				companyId: node.userProfile?.companyId,
				platformId: node.userProfile?.platformId
			}
		};
	}

	toWhereClause(filters: UserProfileRoleFilters): any {
		return {};
	}

	filtersToUrl(filters: UserProfileRoleFilters): any {
		return {
			page: filters.page || 1,
			size: filters.size || 20
		};
	}

	urlToFilters(url: any): UserProfileRoleFilters {
		return new UserProfileRoleFilters({
			page: url.page ? Number(url.page) : 1,
			size: url.size ? Number(url.size) : 20
		});
	}
}
